import { ACTION_TYPE } from "../core/redux/actionType";
import { hasTrippedBreaker, updateBreaker } from "../core/redux/api/circuitBreaker/module";
import { clearSearchHistory } from "../core/redux/api/endpoints";
import { addError, addLoading, getLoading, removeLoadingAndError } from "../core/redux/api/module";
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from "../core/redux/api/reduxStandardApiAction";
import { IAppState } from "../core/redux/IAppState";
import { assoc, isNilOrEmpty } from "../language/module";
import { getResource } from "../language/resources/getResource";

const KEY_ACTION = ACTION_TYPE.CLEAR_SEARCH_HISTORY_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.CLEAR_SEARCH_HISTORY_REQUEST,
  ACTION_TYPE.CLEAR_SEARCH_HISTORY_RESPONSE,
  ACTION_TYPE.CLEAR_SEARCH_HISTORY_ERROR,
];


/**
 * Constructs a guest search Redux Action for submitting the given query to the REST API
 * @param query - The query to search, this will be escaped for you.
 */
export const clearSearchHistoryAction = (resortId: number) => makeApiAction(
  {
    method:   'POST',
    endpoint: state => clearSearchHistory(state.userState.userId, resortId),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { resortId } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
                                    || !!getLoading(state, ACTION_TYPE.CLEAR_SEARCH_HISTORY_REQUEST, KEY_ACTION),
  },
);

const reducer: ApiReducer<any> = (state, action, error, isLoading, payload): IAppState => {
  const resort         = action.meta.resortId;
  const appStateResort = state.selectedResort.resortId;

  // Ignore the results if the response is for a previous query that didn't complete before the
  // user switched resorts  
  if (action.type === ACTION_TYPE.CLEAR_SEARCH_HISTORY_ERROR && !isNilOrEmpty(appStateResort) && appStateResort !== resort) {
    return state;
  }

  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(
      withBreaker,
      KEY_ACTION,
      KEY_ACTION,
      error ?? getResource(state.locale, 'CLEAR_SEARCH_HISTORY_ACTION_ERROR'),
    );
  };

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('userSearchHistory', [], noLoadingOrError);
};

export const clearSearchHistoryReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);